<div class="toolbar">
  <div class="left">
    <h3>{{ "TRANSLATION_OVERRIDES.TITLE" | translate }}</h3>
    <small class="muted">{{ "TRANSLATION_OVERRIDES.DESCRIPTION" | translate }}</small>
  </div>
  <div class="right">
    <input
      #importFile
      type="file"
      accept=".properties,text/plain"
      style="display: none;"
      (change)="onImportFileSelected($event)"
    />

    <div class="filter-checkbox">
      <p-checkbox
        [(ngModel)]="showOnlyOverrides"
        inputId="showOnlyOverrides"
        [binary]="true"
        (onChange)="applyFilter()"
      ></p-checkbox>
      <label for="showOnlyOverrides" class="ml-2">{{ "TRANSLATION_OVERRIDES.SHOW_ONLY_OVERRIDES" | translate }}</label>
    </div>

    <button
      pButton
      type="button"
      icon="pi pi-download"
      class="p-button-outlined p-button-sm"
      [label]="'TRANSLATION_OVERRIDES.EXPORT_OVERRIDES' | translate"
      (click)="exportOverrides()"
      [disabled]="loading || !rows?.length"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-upload"
      class="p-button-outlined p-button-sm"
      [label]="'TRANSLATION_OVERRIDES.IMPORT_OVERRIDES' | translate"
      (click)="importFile.click()"
      [disabled]="loading"
    ></button>

    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        [placeholder]="'TRANSLATION_OVERRIDES.SEARCH_PLACEHOLDER' | translate"
        [(ngModel)]="searchTerm"
        (input)="applyFilter()"
      />
    </span>
  </div>
</div>

<p-table
  [value]="filteredRows"
  styleClass="p-datatable-striped"
  [paginator]="true"
  [rows]="25"
  [rowsPerPageOptions]="[25, 50, 100]"
  [loading]="loading"
  dataKey="key"
  responsiveLayout="scroll"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="min-width: 240px;">Key</th>
      <th *ngFor="let lang of languages" style="min-width: 280px;">
        {{ lang }}
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr>
      <td class="key-cell">
        <div class="key-text">{{ row.key }}</div>
      </td>

      <td *ngFor="let lang of languages" class="lang-cell">
        <div class="cell">
          <div class="cell-top">
            <div class="cell-top-left">
              <span class="badge" *ngIf="row.hasOverride[lang]">override</span>
              <span class="unsaved" *ngIf="row.dirty[lang]">sin guardar</span>
            </div>
            <div class="cell-top-right">
              <button
                *ngIf="row.dirty[lang]"
                pButton
                type="button"
                class="p-button-text p-button-sm"
                icon="pi pi-save"
                (click)="saveCell(row, lang)"
                title="Guardar"
              ></button>
              <button
                *ngIf="row.hasOverride[lang]"
                pButton
                type="button"
                class="p-button-text p-button-sm"
                icon="pi pi-undo"
                (click)="resetToDefault(row, lang)"
                title="Reset to default"
              ></button>
            </div>
          </div>

          <input
            pInputText
            type="text"
            class="cell-input"
            [ngModel]="row.edit[lang]"
            (ngModelChange)="onEditChange(row, lang, $event)"
            (blur)="onCellBlur(row, lang)"
            (keydown.enter)="saveCell(row, lang)"
          />

          <small class="muted" *ngIf="row.base[lang] !== undefined">
            base: {{ row.base[lang] }}
          </small>
          <small class="muted" *ngIf="row.base[lang] === undefined">
            base: (sin valor)
          </small>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="orphans" *ngIf="orphans && (orphans | keyvalue).length">
  <h4>Orphans (overrides sin key en los JSON actuales)</h4>
  <div *ngFor="let kv of (orphans | keyvalue)">
    <strong>{{ kv.key }}</strong>: {{ kv.value.length }} keys
  </div>
</div>
